import { Route } from '@angular/router'
import { PageLayout } from '../../layouts/page-layout.enum'
import { setLayout } from '../../layouts/set-layout.resolver'

export const VendorRoutes: Route[] = [
    {
        path: '',
        redirectTo: 'overview',
        pathMatch: 'full',
    },
    {
        path: 'overview',
        loadComponent: () =>
            import('./page-overview/page-overview.component').then(
                (c) => c.PageOverviewComponent,
            ),
        data: { pageTitle: 'Overview' },
    },
    {
        path: 'benefits',
        loadComponent: () =>
            import('./page-benefits/page-benefits.component').then(
                (c) => c.PageBenefitsComponent,
            ),
        data: { pageTitle: 'Benefits' },
    },
    {
        path: 'create-benefit',
        loadComponent: () =>
            import('./page-create-benefit/page-create-benefit.component').then(
                (c) => c.PageCreateBenefitComponent,
            ),
        data: { pageTitle: 'Create Benefit' },
    },
    {
        path: 'benefits/:id',
        loadComponent: () =>
            import('./page-benefit-details/page-benefit-details.component').then(
                (c) => c.PageBenefitDetailsComponent,
            ),
        data: { pageTitle: 'Benefit Details' },
    },
    {
        path: 'applications',
        loadComponent: () =>
            import('./page-applications/page-applications.component').then(
                (c) => c.PageApplicationsComponent,
            ),
        data: { pageTitle: 'Applications' },
    },
    {
        path: 'vouchers',
        loadComponent: () =>
            import('./page-voucher-redeem/page-voucher-redeem.component').then(
                (c) => c.PageVoucherRedeemComponent,
            ),
        data: { pageTitle: 'Vouchers' },
    },
    {
        path: 'verify-qrcode/:code',
        resolve: { layout: setLayout(PageLayout.Default) },
        loadComponent: () =>
            import('./page-qrcode-verify/page-qrcode-verify.component').then(
                (c) => c.PageQrcodeVerifyComponent,
            ),
        data: { pageTitle: 'QR Code Verification' },
    },
    {
        path: 'targeting',
        loadComponent: () =>
            import('./page-targeting/page-targeting.component').then(
                (c) => c.PageTargetingComponent,
            ),
        data: { pageTitle: 'Targeting & Availability' },
    },
    {
        path: 'team',
        loadComponent: () =>
            import('./page-team/page-team.component').then(
                (c) => c.PageTeamComponent,
            ),
        data: { pageTitle: 'Team Members' },
    },
    {
        path: 'analytics',
        loadComponent: () =>
            import('./page-analytics/page-analytics.component').then(
                (c) => c.PageAnalyticsComponent,
            ),
        data: { pageTitle: 'Analytics' },
    },
    {
        path: 'company-profile',
        loadComponent: () =>
            import('./page-company-profile/page-company-profile.component').then(
                (c) => c.PageCompanyProfileComponent,
            ),
        data: { pageTitle: 'Company Profile' },
    },
    {
        path: 'settings',
        loadComponent: () =>
            import('./page-settings/page-settings.component').then(
                (c) => c.PageSettingsComponent,
            ),
        data: { pageTitle: 'Settings' },
    },
]
